import NamedDto from 'modules/base/dto/NamedDto';

export class worksheetModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.min_value = null;
		/** @type {string} */
		this.max_value = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.worksheet = null;
		/** @type {string} */
		this.cell = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _worksheetModelInputAttributeEditDtoProps	
	 * @property {string} type
	 * @property {string} value
	 * @property {string} min_value
	 * @property {string} max_value
	 * @property {string} uom
	 * @property {string} worksheet
	 * @property {string} cell
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _worksheetModelInputAttributeEditDtoProps} worksheetModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {worksheetModelInputAttributeEditDtoProps} props
	 * @returns {worksheetModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.value = props.value;
		this.min_value = props.min_value;
		this.max_value = props.max_value;
		this.uom = props.uom;
		this.worksheet = props.worksheet;
		this.cell = props.cell;
		this.orderIndex = props.orderIndex;

		return this;
	}
}

export default worksheetModelInputAttributeEditDto;